import { render, staticRenderFns } from "./CardChallengesPostCard.vue?vue&type=template&id=f8c405c4&"
import script from "./CardChallengesPostCard.vue?vue&type=script&lang=js&"
export * from "./CardChallengesPostCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports